<template>

<div id="WeSayHello" class="GameInCCAmfi"> 
  <div id="score">
    <br />
    <p>{{goals.title}} - {{goals.author}} {{goals.ageSTO}} : {{goals.ageFAS}} </p>
     <button @click="goals.ageSTO++">Goal home</button>
    <button @click="goals.ageFAS++">Goal away</button>
    <br>
         <button @click="goals.ageSTO=Math.max(goals.ageSTO-1,0)">Remove goal home</button>
    <button @click="goals.ageFAS=Math.max(goals.ageFAS-1,0)">Remove goal away</button>

    <br/>

  </div>

<br>
<br>
<br>

  <div id="penalty">
 <p>Home - {{convertTo00(penalties.displayMinutesSTO)}} : {{convertTo00(penalties.displaySecondsSTO)}} </p>
   <p> Away - {{convertTo00(penalties.displayMinutesFAS)}} : {{convertTo00(penalties.displaySecondsFAS)}} </p>
     <button @click="penalties.displayMinutesSTO=Math.max(penalties.displayMinutesSTO+1, 0)">Add penalty home </button>
    <button @click="penalties.displayMinutesFAS=Math.max(penalties.displayMinutesFAS+1, 0)">Add penalty away</button>
    <br>
       <button @click="penalties.displayMinutesSTO=Math.max(penalties.displayMinutesSTO-1, 0)">Remove penalty home</button>
    <button @click="penalties.displayMinutesFAS=Math.max(penalties.displayMinutesFAS-1, 0)">Remove penalty away</button>
      
  </div>

</div>  


</template>

<script>
import '@/css/SondreGame.css'
import '@/scss/WeSayHello.scss'

export default {
  name: 'SondreGame',

  data () {
    return {
      goals: {
        title: 'Storhamar',
        author: 'Frisk Asker',
        ageSTO: '0',
        ageFAS: '0'
      },

      penalties: {
        displayMinutesSTO: 0,
        displaySecondsSTO: 0,
        displayMinutesFAS: 0,
        displaySecondsFAS: 0
      
      
      }
      
    }
  },
  
  methods:{
  convertTo00 (num) {
    if (typeof num !== 'number') return;

    var str = num.toString();

    if (str[0] === '-' && str.length < 3) str = `-0${str[1]}`
    else if (str.length < 2) str = `0${str}`

    return str
  }
}
} 


</script>





// WEBPACK FOOTER //
// src/views/SondreGame.vue